var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn--close",on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":require("../assets/close.svg"),"alt":"關閉","loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }